/** Pure formatting helpers for analytics widgets (kept out of the component
 *  file so react-refresh stays happy). */
import { formatCurrency } from "@/lib/format";

import type { MetricMap } from "./types";

/** "compliance_rate" → "Compliance rate". Drops a trailing `_eur` so the
 *  euro sign isn't doubled — `formatMetric` already prefixes "€" to the value
 *  (e.g. "cost_per_inspection_eur" → label "Cost per inspection", value "€25.29"). */
export function humanize(key: string): string {
  const s = key.replace(/_eur$/i, "").replace(/_/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Format a metric for display. Rates (0–1, key contains "rate") → percent. */
export function formatMetric(key: string, value: MetricMap[string]): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "boolean") return value ? "✓" : "—";
  if (typeof value === "number") {
    if (/rate|ratio/.test(key) && value >= 0 && value <= 1) {
      return `${(value * 100).toFixed(1)}%`;
    }
    if (key.includes("eur")) return formatCurrency(value);
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }
  return String(value);
}
